import { MapType } from '@/types/common';
import { JobTitleType, JobTitleContextType } from '@/types/job-title';

export const WORK_EXPERIENCE_NONE = 'work_experience_none';
export const WORK_EXPERIENCE_0 = 'work_experience_0';
export const WORK_EXPERIENCE_1_3 = 'work_experience_1_3';
export const WORK_EXPERIENCE_3_5 = 'work_experience_3_5';
export const WORK_EXPERIENCE_5_10 = 'work_experience_5_10';
export const WORK_EXPERIENCE_10_PLUS = 'work_experience_10_plus';

export const WORK_EXPERIENCE_ARRAY = [
  WORK_EXPERIENCE_0,
  WORK_EXPERIENCE_1_3,
  WORK_EXPERIENCE_3_5,
  WORK_EXPERIENCE_5_10,
  WORK_EXPERIENCE_10_PLUS,
  WORK_EXPERIENCE_NONE,
];

export const WORK_EXPERIENCE_MAP: MapType = {
  [WORK_EXPERIENCE_0]: '应届',
  [WORK_EXPERIENCE_1_3]: '1-3年',
  [WORK_EXPERIENCE_3_5]: '3-5年',
  [WORK_EXPERIENCE_5_10]: '5-10年',
  [WORK_EXPERIENCE_10_PLUS]: '>10年',
  [WORK_EXPERIENCE_NONE]: '不限经验',
};

export const WORK_EXPERIENCE_CITY_MAP: MapType = {
  [WORK_EXPERIENCE_0]: '1年以内',
  [WORK_EXPERIENCE_1_3]: '1-3年',
  [WORK_EXPERIENCE_3_5]: '3-5年',
  [WORK_EXPERIENCE_5_10]: '5-10年',
  [WORK_EXPERIENCE_10_PLUS]: '>10年',
  [WORK_EXPERIENCE_NONE]: '不限经验',
};

export const EDUCATION_NONE = 'education_none';
export const EDUCATION_COLLEGE = 'education_college';
export const EDUCATION_BACHELOR = 'education_bachelor';
export const EDUCATION_MASTER = 'education_master';
export const EDUCATION_DOCTOR = 'education_doctor';

export const EDUCATION_MAP: MapType = {
  [EDUCATION_COLLEGE]: '专科',
  [EDUCATION_BACHELOR]: '本科',
  [EDUCATION_MASTER]: '硕士',
  [EDUCATION_DOCTOR]: '博士',
  [EDUCATION_NONE]: '不限学历',
};

// SCALE = WIDTH_TIP / WIDTH_BAR_CHART
export const SCALE_BAR_TIP = 0.0037;

export const SALARY_RANGES = ['0-8k', '8-15k', '15-30k', '>30k'];

export const COMPETITIVE_SCORE_INTRO =
  '0.3*MinMax（平均薪资）+0.6*MinMax（职位开放数增长率）+0.1*MinMax（生活成本）';

export const STORAGE_KEY_VALUE = 'jobTitleValue';

export const ACTIVE_TABS = [
  {
    title: '职业全景',
    en: 'position-overview',
  },
  {
    title: '发展路线',
    en: 'development-path',
  },
  {
    title: '简历重点',
    en: 'resume-focus',
  },
  {
    title: '薪资洞察',
    en: 'salary-insight',
  },
  {
    title: '招聘趋势',
    en: 'recruitment-trend',
  },
];

export const POSITION_OVERVIEW_ITEMS = [
  {
    name: '职位介绍',
    id: 'position-overview_position-detail',
  },
  {
    name: 'AI时代下的职业前景',
    id: 'position-overview_ai-impact',
  },
  {
    name: '行业前景与市场需求',
    id: 'position-overview_market-demand',
  },
  {
    name: '适合人群',
    id: 'position-overview_suitable-people',
  },
  {
    name: '如何入行',
    id: 'position-overview_how-to-enter',
  },
];

export const DEVELOPMENT_PATH_ITEMS = [
  {
    name: '职业成长路径',
    id: 'development-path_career-path',
  },
  {
    name: '规划职业阶段',
    id: 'development-path_career-stage',
  },
  {
    name: '能力发展地图',
    id: 'development-path_capability-map',
  },
];

export const RESUME_FOCUS_ITEMS = [
  {
    name: '核心能力',
    id: 'resume-focus_core-ability',
  },
  {
    name: '呈现工作成果',
    id: 'resume-focus_achievement',
  },
  {
    name: 'HR是如何筛选简历的',
    id: 'resume-focus_hr-screening',
  },
  {
    name: '让你的简历脱颖而出',
    id: 'resume-focus_stand-out',
  },
  {
    name: '加分亮点让你脱颖而出',
    id: 'resume-focus_highlight',
  },
  {
    name: '市场偏爱的深层特质',
    id: 'resume-focus_market-preference',
  },
  {
    name: '必须规避的表述陷阱',
    id: 'resume-focus_avoid-traps',
  },
];

export const SALARY_INSIGHT_ITEMS = [
  {
    name: '薪酬概览',
    id: 'salary-insight_overview',
  },
  {
    name: '工作年限',
    id: 'salary-insight_experience',
  },
  {
    name: '学历背景',
    id: 'salary-insight_education',
  },
  {
    name: '所在行业',
    id: 'salary-insight_industry',
  },
  {
    name: '所在城市',
    id: 'salary-insight_city',
  },
];

export const RECRUITMENT_TREND_ITEMS = [
  {
    name: '市场需求',
    id: 'recruitment-trend_market-demand',
  },
  {
    name: '不同经验岗位的需求分析',
    id: 'recruitment-trend_experience-analysis',
  },
  {
    name: '不同行业的需求分析',
    id: 'recruitment-trend_industry-analysis',
  },
  {
    name: '不同城市的需求分析',
    id: 'recruitment-trend_city-analysis',
  },
];

const DEFAULT_JOB_TITLE_DATA: JobTitleType = {
  id: '',
  name: '',
  display_name: '',
  aliases: [],
  province_city_data: [],
  l1_l2_list: [],
  description: '',
  job_difficulty_rating: null,
  job_challenge_rating: null,
  job_future_rating: null,
  job_open_details: {
    current_count: NaN,
    open_job_details: { by_year: [], by_month: [] },
    new_job_details: {
      by_month: [],
      by_experience: {
        by_month: [],
      },
      salary_max_of_all_period: NaN,
      salary_min_of_all_period: NaN,
      last_month_by_experience: [{ name: '', value: [] }],
    },
    avg_new_job_details: {
      monthly: {
        count: NaN,
        rank: NaN,
        by_experience: [],
      },
    },
    updated_at: '',
    seo_content: {},
  },
  current_count_group_by_experience: [],
  locations: [],
  salary_rank: { current_rank: 0, l1_id: '', l1_name: '', ranks: [] },
  salary_details: {
    max: NaN,
    min: NaN,
    avg: NaN,
    competitive_rate: NaN,
    competitive_rank: NaN,
    avg_rank_details: {
      by_location: NaN,
      by_job_title: NaN,
    },
    avg_growth_rate_details: {
      by_experience: {
        value: NaN,
        rank: NaN,
      },
    },
    avg_salary_details: {
      by_year: [],
      by_month: [],
    },
    avg_value_by_education_details: {},
    avg_value_by_experience_details: {},
    distribution_details: {},
  },
};

export const DEFAULT_JOB_TITLE_CONTEXT_VALUE: JobTitleContextType = {
  jobTitle: DEFAULT_JOB_TITLE_DATA,
  jobTitleSummary: { new_job_details: { by_month: [] } },
  displayName: '',
};
